export default "__VITE_ASSET__BEysg3en__"